export const UpdatedAt = (rowData: { updatedAt: string }) => (
  <span>{new Date(rowData.updatedAt).toLocaleDateString()}</span>
);
